import { CORE_PLUGIN } from "@/core"
import type { Plugin } from "@/plugins"
import { injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import AfterSale from './AfterSale.vue'
import OrderAddress from './OrderAddress.vue'
import AdjustDetail from './AdjustDetail.vue'
import { defineStore } from "pinia"

export const AfterSalePageOptionsInjectKey = "AfterSalePageOptionsInjectKey"
export const AfterSaleStore = defineStore("AfterSaleStore", {
  state: () => ({
    showFlag: '',
  }),
})
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) => c.resolve(AfterSalePlugin))
  }
])
@injectable()
export class AfterSalePlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    app.component("FlashbaseAfterSale", AfterSale)
    app.component("FlashbaseOrderAddress", OrderAddress)
    app.component("FlashbaseAdjustDetail", AdjustDetail)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void { }
}
